/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FundsViewModel } from './FundsViewModel';
import {
    FundsViewModelFromJSON,
    FundsViewModelFromJSONTyped,
    FundsViewModelToJSON,
} from './FundsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfFundsViewModel
 */
export interface ResultOfFundsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfFundsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFundsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfFundsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFundsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfFundsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfFundsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfFundsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {FundsViewModel}
     * @memberof ResultOfFundsViewModel
     */
    data?: FundsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfFundsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfFundsViewModel interface.
 */
export function instanceOfResultOfFundsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfFundsViewModelFromJSON(json: any): ResultOfFundsViewModel {
    return ResultOfFundsViewModelFromJSONTyped(json, false);
}

export function ResultOfFundsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfFundsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : FundsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfFundsViewModelToJSON(value?: ResultOfFundsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': FundsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

